<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#e6b98a"
    inactive-color="#a5a7ad"
    :border="false"
    z-index="999"
    class="sincere-tabbar"
  >
    <van-tabbar-item
      v-for="(item, index) in tabItems"
      :key="item.name"
      :to="item.to"
    >
      <span>{{ item.label }}</span>
      <template #icon>
        <img :src="tabIcon(item, index)" :alt="item.label">
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
const TAB_ITEMS = [
  {
    name: 'home',
    label: 'Home',
    to: '/Home',
    icon: '/img/neww/zy.png',
    activeIcon: '/img/neww/zy.png'
  },
  {
    name: 'reviews',
    label: 'Reviews',
    to: '/Reviews',
    icon: 'https://m.sincereloves.online/icon/icon_reviews.png',
    activeIcon: 'https://m.sincereloves.online/icon/icon_reviews_1.png'
  },
  {
    name: 'Lottery',
    label: 'Events',
    to: '/Lottery',
    icon: '/img/neww/dt.png',
    activeIcon: '/img/neww/dt1.png'
  },
  {
    name: 'video',
    label: 'Video',
    to: '/Video',
    icon: '/img/neww/video.png',
    activeIcon: '/img/neww/video.png'
  },
  {
    name: 'mine',
    label: 'Me',
    to: '/Mine',
    icon: '/img/neww/wd.png',
    activeIcon: '/img/neww/wd.png'
  }
];

export default {
  data() {
    return {
      show: false,
      active: 0,
      tabItems: TAB_ITEMS
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        const currentIndex = this.tabItems.findIndex((item) => item.name === to.name);
        this.active = currentIndex === -1 ? 0 : currentIndex;
        this.show = currentIndex !== -1;
      }
    }
  },
  methods: {
    tabIcon(item, index) {
      return this.active === index ? (item.activeIcon || item.icon) : item.icon;
    }
  }
};
</script>

<style lang="less" scoped>
.sincere-tabbar {
  height: 112px;
  background: #1c1c1e;
  box-shadow: 0 -1px 0 rgba(255, 255, 255, 0.04);
}

::v-deep .van-tabbar {
  height: 112px;
}

::v-deep .van-tabbar-item {
  background: #1c1c1e;
}

::v-deep .van-tabbar-item__icon {
  margin-bottom: 8px;
}

::v-deep .van-tabbar-item__icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

::v-deep .van-tabbar-item__text {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.1;
}
</style>
